export default [
  {
    x: 475,
    y: 294,
    type: 'bullet',
    fill: 'rgb(185, 211, 220)',
    label: 'London',
    latitude: 51.5002,
    longitude: -0.1262,
  },
  {
    x: 510,
    y: 275,
    type: 'bullet',
    fill: 'rgb(185, 211, 220)',
    label: 'Copenhagen',
    latitude: 55.6763,
    longitude: 12.5681,
  },
  {
    x: 487,
    y: 297,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Brussels',
    latitude: 50.8371,
    longitude: 4.3676,
  },
  {
    x: 414,
    y: 227,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Reykjavik',
    latitude: 64.1353,
    longitude: -21.8952,
  },
  {
    x: 481,
    y: 306,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Paris',
    latitude: 48.8567,
    longitude: 2.351,
  },
  {
    x: 581,
    y: 275,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Moscow',
    latitude: 55.7558,
    longitude: 37.6176,
  },
  {
    x: 465,
    y: 340,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Madrid',
    latitude: 40.4167,
    longitude: -3.7033,
  },
  {
    x: 690,
    y: 380,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'New Delhi',
    latitude: 28.6353,
    longitude: 77.225,
  },
  {
    x: 867,
    y: 356,
    r: 0.2,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Tokyo',
    latitude: 35.6785,
    longitude: 139.6823,
  },
  {
    x: 259,
    y: 345,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Washington',
    latitude: 38.8921,
    longitude: -77.0241,
  },
  {
    x: 881.5,
    y: 577,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Melbourne',
    latitude: -37.813629,
    longitude: 144.963058,
  },
  {
    x: 566,
    y: 342,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Ankara',
    latitude: 39.9439,
    longitude: 32.856,
  },
  {
    x: 311,
    y: 566,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Buenos Aires',
    latitude: -34.6118,
    longitude: -58.4173,
  },
  {
    x: 343,
    y: 506,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Brasilia',
    latitude: -15.7801,
    longitude: -47.9292,
  },
  {
    x: 262,
    y: 321,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Ottawa',
    latitude: 45.4235,
    longitude: -75.6979,
  },
  {
    x: 518,
    y: 475.5,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Kinshasa',
    latitude: -4.3369,
    longitude: 15.3271,
  },
  {
    x: 563,
    y: 375,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Cairo',
    latitude: 30.0571,
    longitude: 31.2272,
  },
  {
    x: 553,
    y: 537,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Pretoria',
    latitude: -25.7463,
    longitude: 28.1876,
  },
  {
    x: 425.9,
    y: 421.4,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Dakar',
    latitude: 14.693425,
    longitude: -17.447938,
  },
  {
    x: 586.5,
    y: 473,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Mombasa',
    latitude: -4.05052,
    longitude: 39.667169,
  },
  {
    x: 561,
    y: 470,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Ngara',
    latitude: -1.2832533,
    longitude: 36.8172449,
  },
  {
    x: 563,
    y: 450,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Juba',
    latitude: 4.8472017,
    longitude: 31.5951655,
  },
  {
    x: 484,
    y: 444.5,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Lagos',
    latitude: 6.4550575,
    longitude: 3.3941795,
  },
  {
    x: 533.2664953167957,
    y: 290.67072055266874,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Warsaw',
    latitude: 52.2319581,
    longitude: 21.0067249,
  },
  {
    x: 512.2629523880797,
    y: 289.3736995043222,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Berlin',
    latitude: 52.5170365,
    longitude: 13.3888599,
  },
  {
    x: 510,
    y: 333.8,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Rome',
    latitude: 41.8933203,
    longitude: 12.4829321,
  },
  {
    x: 528.5,
    y: 188,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Tromso',
    latitude: 69.649208,
    longitude: 18.9543434,
  },
  {
    x: 544,
    y: 251,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Helsinki',
    latitude: 60.1674881,
    longitude: 24.9427473,
  },
  {
    x: 504.9568273555848,
    y: 253,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Oslo',
    latitude: 59.9133301,
    longitude: 10.7389701,
  },
  {
    x: 525.1725398407159,
    y: 256,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Stockholm',
    latitude: 59.3251172,
    longitude: 18.0710935,
  },
  {
    x: 547,
    y: 175,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Nordkapp',
    latitude: 71.1699506,
    longitude: 25.7858893,
  },
  {
    x: 561,
    y: 298.7779415243888,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Kyiv',
    latitude: 50.4500336,
    longitude: 30.5241361,
  },
  {
    x: 668,
    y: 346.5,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Dushanbe',
    latitude: 38.5762709,
    longitude: 68.7863573,
  },
  {
    x: 680,
    y: 408,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Mumbai',
    latitude: 19.0759899,
    longitude: 72.8773928,
  },
  {
    x: 699,
    y: 442.5,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Colombo',
    latitude: 6.9349969,
    longitude: 79.8538463,
  },
  {
    x: 714,
    y: 382.3,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Kathmandu',
    latitude: 27.708317,
    longitude: 85.3205817,
  },
  {
    x: 815.5,
    y: 371,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Shanghai',
    latitude: 31.2322758,
    longitude: 121.4692071,
  },
  {
    x: 800,
    y: 338,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Beijing',
    latitude: 39.906217,
    longitude: 116.3912757,
  },
  {
    x: 898.2,
    y: 565,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Sydney',
    latitude: -33.8548157,
    longitude: 151.2164539,
  },
  {
    x: 801,
    y: 556,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Perth',
    latitude: -31.9527121,
    longitude: 115.8604796,
  },
  {
    x: 966,
    y: 574,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Auckland',
    latitude: -36.852095,
    longitude: 174.7631803,
  },
  {
    x: 54.5,
    y: 245,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Anchorage',
    latitude: 61.2163129,
    longitude: -149.8948523,
  },
  {
    x: 129.5,
    y: 304.5,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Vancouver',
    latitude: 49.2608724,
    longitude: -123.1139529,
  },
  {
    x: 143,
    y: 362,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Los Angeles',
    latitude: 34.0536909,
    longitude: -118.242766,
  },
  {
    x: 256.0608456551366,
    y: 487.4930349608487,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Panama City',
    latitude: 8.9714493,
    longitude: -79.5341802,
  },
  {
    x: 276,
    y: 560,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Santiago',
    latitude: 9.8694792,
    longitude: -83.7980749,
  },
  {
    x: 526.7,
    y: 563.5,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Cape Town',
    latitude: -33.928992,
    longitude: 18.417396,
  },
  {
    x: 330,
    y: 226.7,
    fill: 'rgb(185, 211, 220)',
    type: 'bullet',
    label: 'Nuuk',
    latitude: 64.175029,
    longitude: -51.7355386,
  },
];
